// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"loading-overlay__loadingOverlay__nfDFC"};